import { gql, useMutation } from '@provision/graphql-client';
import { useCallback } from 'react';

const GENERATE_STRIPE_BILLING_PORTAL_URL_QUERY = gql`
  mutation GenerateStripeBillingPortalUrl($addressId: String!) {
    generateStripeBillingPortalUrl(params: { addressId: $addressId }) {
      url
    }
  }
`;

interface GenerateStripeBillingPortalUrlQuery {
  generateStripeBillingPortalUrl: {
    url: string;
  };
}

export const useStripeBillingPortalUrl = () => {
  const [generateStripeBillingPortalUrlMutation] =
    useMutation<GenerateStripeBillingPortalUrlQuery>(GENERATE_STRIPE_BILLING_PORTAL_URL_QUERY);

  const generateStripeBillingPortalUrl = useCallback(
    async ({ addressId }: { addressId: string }) => {
      if (!addressId) return;

      const { data } = await generateStripeBillingPortalUrlMutation({
        variables: {
          addressId,
        },
      });

      return data?.generateStripeBillingPortalUrl || { url: '' };
    },
    [generateStripeBillingPortalUrlMutation],
  );

  return {
    generateStripeBillingPortalUrl,
  };
};
